// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6s-4";
export var collapsed = "_6s-1";
export var headerBar = "_6s-0";
export var leftHeaderContent = "_6s-3";
export var subjectContainer = "_6s-2";